/*
 * Tupaia
 * Copyright (c) 2017 - 2021 Beyond Essential Systems Pty Ltd
 */
import React, { createContext, useContext } from "react";
import fijiConfig from "./fiji.json";
import samoaConfig from "./samoa.json";
import palauConfig from "./palau.json";
import kiribatiConfig from "./kiribati.json";

const countryCode = process.env.REACT_APP_COUNTRY_CODE;

const countryConfigs = {
  FJ: fijiConfig,
  WS: samoaConfig,
  PW: palauConfig,
  KI: kiribatiConfig,
};

const config = countryConfigs[countryCode];

const configContext = createContext(config);
const { Provider } = configContext;

// eslint-disable-next-line react/prop-types
const ConfigContextProvider = ({ children }) => {
  return (
    <Provider value={config} displayName="ResultsViewerConfig">
      {children}
    </Provider>
  );
};

const useConfig = () => {
  return useContext(configContext);
};

// Note: the store can be debugged in dev tools using a chrome plugin.
// https://chrome.google.com/webstore/detail/react-context-devtool/oddhnidmicpefilikhgeagedibnefkcf?hl=en
export { useConfig, ConfigContextProvider };
